import ContactContent from "../components/Contact/ContactContent";

export default function Contact(){
    return(
       <div>
       <ContactContent/>
       </div>
    )
}